import { render, staticRenderFns } from "./CreateLocation.vue?vue&type=template&id=58dd4c5e"
import script from "./create.js?vue&type=script&lang=js&external"
export * from "./create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports